<template>
    <div class="mb-3">
<b-form @submit.stop.prevent>



        <b-tabs
            content-class="mt-3"
            >
            <b-tab :title="trans.labels['shipping_addresses.type.from']" v-if="prefixes.includes('from')">
                <h6 v-if="!simple"><strong>タスキー登録データから取得</strong></h6>
                <vue-select
                    v-model="data_db_selected['from']"
                    :options="$store.state.app.data.shipping_addresses.filter((v) => { return v.type === 'from' }) || []"
                    label="name"
                    size="sm"
                    @input="onSelect($event, 'from')"
                    >
                </vue-select>
            </b-tab>

            <b-tab :title="trans.labels['shipping_addresses.type.importer']" v-if="prefixes.includes('importer')">
                <h6 v-if="!simple"><strong>タスキー登録データから取得</strong></h6>
                <vue-select
                    v-model="data_db_selected['importer']"
                    :options="$store.state.app.data.shipping_addresses.filter((v) => { return v.type === 'importer' }) || []"
                    label="name"
                    size="sm"
                    @input="onSelect($event, 'importer')"
                    >
                </vue-select>
            </b-tab>

            <b-tab :title="trans.labels['shipping_addresses.type.to']" v-if="prefixes.includes('to')">
                <h6 v-if="!simple"><strong>タスキー登録データから取得</strong></h6>
                <vue-select
                    v-model="data_db_selected['to']"
                    :options="$store.state.app.data.shipping_addresses.filter((v) => { return v.type === 'to' }) || []"
                    label="name"
                    size="sm"
                    @input="onSelect($event, 'to')"
                    >
                </vue-select>

                <template v-if="!simple">
                <br>

                <h6><strong>プラットフォームから取得</strong></h6>
    
<!--
                <SelectUserInGroup
                    v-model="order_user_id"
                    />
-->
    
                <b-input-group class="">
                    <b-form-input v-model="order_query" placeholder="商品名、購入者、注文番号" @keydown.enter.native="fetchOrders"></b-form-input>
                    <b-form-select v-model="order_provider" class="order-provider">
                         <b-form-select-option value="">All</b-form-select-option>
                         <b-form-select-option value="ebay">eBay</b-form-select-option>
<!--
                         <b-form-select-option value="amazon">Amazon US</b-form-select-option>
                         <b-form-select-option value="amazon_au">Amazon AU</b-form-select-option>
                         <b-form-select-option value="amazon_ca">Amazon CA</b-form-select-option>
-->
                    </b-form-select>
                    <b-input-group-append>
                    </b-input-group-append>
                    <template #append>
                        <b-button
                            variant="secondary"
                            @click="fetchOrders"
                            >
                            検索
                        </b-button>
                    </template>
                </b-input-group>

                <b-table small :fields="[ '読込先', '日付', '商品名', '受取人', ]" :items="data_orders" hover v-if="data_orders.length">
                    <template #cell(読込先)="data">
                        <div class="text-nowrap">
                            <a href="javascript:void(0)" @click="onSelect(data.item, 'to')">選択</a>
                        </div>
<!--
                        <div v-for="prefix in prefixes" class="text-nowrap">
                            <a href="javascript:void(0)" @click="onSelect(data.item, prefix)">{{ trans.labels['shipping_addresses.type.' + prefix] }}</a>
                        </div>
-->
                    </template>

                    <template #cell(日付)="data">
                        <small>#{{ data.item.order_id }}</small><br>
                        {{ data.item.ordered_at | BaseDatetimeFormatter }}
                    </template>

                    <template #cell(商品名)="data">
                        <small>#{{ data.item.sku }}</small><br>
                        {{ data.item.title }}<br>

                        <span v-if="data.item['cost_price']">商品代:{{ data.item['cost_price']['value'] + data.item['cost_price']['currencyID'] }} x{{ data.item['quantity'] }}</span>
                        <span v-if="data.item['cost_shipping']">+ 送料:{{ data.item['cost_shipping']['value'] + data.item['cost_shipping']['currencyID'] }}</span>
<!--
                        <span v-if="data.item['cost_handling']">+ 手数料:{{ data.item['cost_handling']['value'] + data.item['cost_handling']['currencyID'] }}</span>
                        <span v-if="data.item['cost_total']">= {{ data.item['cost_total']['value'] + data.item['cost_total']['currencyID'] }}</span><br>
-->
                    </template>

                    <template #cell(受取人)="data">
                        {{ data.item.address.Name }}
                        ({{ data.item.buyer_id }})
                    </template>
                </b-table>
                </template>
            </b-tab>

            <b-tab title="内容物" v-if="prefixes.includes('shipping_item')">
                <h6><strong>内容物</strong></h6>
                <h6><strong>タスキー登録データから取得</strong></h6>
                <vue-select
                    v-model="data_db_selected['shipping_item']"
                    :options="$store.state.app.data.shipping_items || []"
                    label="name"
                    size="sm"
                    @input="onSelect($event, 'shipping_item')"
                    >
                </vue-select>
            </b-tab>
        </b-tabs>




</b-form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import FormModal from '@/components/FormModal.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ShareButtons from '@/components/ShareButtons.vue'
import InputError from '@/components/InputError.vue'
import SelectUserInGroup from '@/components/SelectUserInGroup.vue'

export default {
    components: {
        GridPage,
        FormModal,
        Item,
        ItemBadges,
        ShareButtons,
        InputError,
        SelectUserInGroup,
    },
    props: {
        error: {
            type: Object,
            required: false,
            default() {
                return {}
            },
        },
        prefixes: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        simple: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },

        order_user_id: {
            type: [ Number, String, ],
            required: false,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            data_db_selected: {
                from: null,
                to: null,
                importer: null,
            },

//            order_user_id: null,
            order_query: '',
            order_provider: '',
            order_type: 'word',
            data_orders: [],
            data_orders_selected: {},
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
            'filter4address',
        ])
    },
    mounted() {},
    methods: {
        fetchOrders ($event) {
            this.$utils.empty(this.data_orders_selected)
            this.$store
                .dispatch('shipping/fetch_orders', {
                    order_user_id: this.order_user_id,
                    provider_type: this.order_provider,
                    order_type: this.order_type,
                    order_query: this.order_query,
                })
                .then((response) => {
                    this.data_orders = response.data
                })
                .catch((error) => {
                })
        },
        onSelect (item, prefix) {
            this.data_db_selected[prefix] = null
            this.$nextTick(() => {
                let price = null
                let currency = null
                let product = null
                let quantity = null
                if (item.cost_price) {
                    if (item.cost_price.value) {
                        price = item.cost_price.value
                    }
                    if (item.cost_price.currencyID) {
                        currency = item.cost_price.currencyID
                    }
                    if (item.title) {
                        product = item.title
                    }
                    if (item.quantity) {
                        quantity = item.quantity
                    }
                }
                this.$emit('select', this.filter4address(item), prefix, this.order_user_id, price, currency, product, quantity)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.order-provider {
    max-width: 8em;
}
</style>


